// extracted by mini-css-extract-plugin
module.exports = {"menu_button":"a2c79c7e7d--menu_button--Psnyj","title":"a2c79c7e7d--title--gwtbB","icon-photo":"a2c79c7e7d--icon-photo--QDdAg","icon-video":"a2c79c7e7d--icon-video--g19wQ"};